export const formatPrice = (value, currency, locale) =>
  value.toLocaleString(locale, {
    style: 'currency',
    localeMatcher: 'best fit',
    currency: currency || 'EUR',
  });
